var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZenyumWorkingHoursBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 922,
    height: 1000,
    viewBox: "0 0 922 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2748_47077)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 922,
    height: 1000,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-760 385L972.051 -615",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-755 393.66L977.051 -606.34",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-750 402.321L982.051 -597.679",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-745 410.981L987.051 -589.019",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-740 419.641L992.051 -580.359",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-735 428.301L997.051 -571.699",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-730 436.961L1002.05 -563.039",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-725 445.622L1007.05 -554.378",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-720 454.282L1012.05 -545.718",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-715 462.942L1017.05 -537.058",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-710 471.603L1022.05 -528.397",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-705 480.263L1027.05 -519.737",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-700 488.923L1032.05 -511.077",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-695 497.583L1037.05 -502.417",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-690 506.244L1042.05 -493.756",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-685 514.904L1047.05 -485.096",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-680 523.564L1052.05 -476.436",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-675 532.224L1057.05 -467.776",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-670 540.885L1062.05 -459.115",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-665 549.545L1067.05 -450.455",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-660 558.205L1072.05 -441.795",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-655 566.865L1077.05 -433.135",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-650 575.526L1082.05 -424.474",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-645 584.186L1087.05 -415.814",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-640 592.846L1092.05 -407.154",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-635 601.506L1097.05 -398.494",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-630 610.167L1102.05 -389.834",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-625 618.827L1107.05 -381.173",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-620 627.487L1112.05 -372.513",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-615 636.147L1117.05 -363.853",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-610 644.808L1122.05 -355.192",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-605 653.468L1127.05 -346.532",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-600 662.128L1132.05 -337.872",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-595 670.788L1137.05 -329.212",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-590 679.449L1142.05 -320.551",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-585 688.109L1147.05 -311.891",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-580 696.769L1152.05 -303.231",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-575 705.429L1157.05 -294.571",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-570 714.09L1162.05 -285.91",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-565 722.75L1167.05 -277.25",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-560 731.41L1172.05 -268.59",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-555 740.07L1177.05 -259.93",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-550 748.731L1182.05 -251.269",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-545 757.391L1187.05 -242.609",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-540 766.051L1192.05 -233.949",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-535 774.711L1197.05 -225.289",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-530 783.372L1202.05 -216.628",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-525 792.032L1207.05 -207.968",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-520 800.692L1212.05 -199.308",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-515 809.353L1217.05 -190.647",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-510 818.013L1222.05 -181.987",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-505 826.673L1227.05 -173.327",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-500 835.333L1232.05 -164.667",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-495 843.993L1237.05 -156.007",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-490 852.654L1242.05 -147.346",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-485 861.314L1247.05 -138.686",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-480 869.974L1252.05 -130.026",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-475 878.635L1257.05 -121.365",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-470 887.295L1262.05 -112.705",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-465 895.955L1267.05 -104.045",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-460 904.615L1272.05 -95.3848",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-455 913.275L1277.05 -86.7246",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-450 921.936L1282.05 -78.0642",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-445 930.596L1287.05 -69.4041",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-440 939.256L1292.05 -60.7437",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-435 947.917L1297.05 -52.0835",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-430 956.577L1302.05 -43.4234",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-425 965.237L1307.05 -34.763",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-420 973.897L1312.05 -26.1028",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-415 982.558L1317.05 -17.4424",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-410 991.218L1322.05 -8.78225",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-405 999.878L1327.05 -0.12209",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-400 1008.54L1332.05 8.53831",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-395 1017.2L1337.05 17.1985",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-390 1025.86L1342.05 25.8589",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-385 1034.52L1347.05 34.519",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-380 1043.18L1352.05 43.1792",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-375 1051.84L1357.05 51.8396",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-370 1060.5L1362.05 60.4997",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 1069.16L1367.05 69.1601",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-360 1077.82L1372.05 77.8203",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-355 1086.48L1377.05 86.4804",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-350 1095.14L1382.05 95.1408",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-345 1103.8L1387.05 103.801",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-340 1112.46L1392.05 112.461",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-335 1121.12L1397.05 121.122",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-330 1129.78L1402.05 129.782",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325 1138.44L1407.05 138.442",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-320 1147.1L1412.05 147.102",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-315 1155.76L1417.05 155.763",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-310 1164.42L1422.05 164.423",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-305 1173.08L1427.05 173.083",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-300 1181.74L1432.05 181.743",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-295 1190.4L1437.05 190.404",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-290 1199.06L1442.05 199.064",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-285 1207.72L1447.05 207.724",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-280 1216.38L1452.05 216.384",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-275 1225.04L1457.05 225.045",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-270 1233.7L1462.05 233.705",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-265 1242.37L1467.05 242.365",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-260 1251.03L1472.05 251.025",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-255 1259.69L1477.05 259.686",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-250 1268.35L1482.05 268.346",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-245 1277.01L1487.05 277.006",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-240 1285.67L1492.05 285.666",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-235 1294.33L1497.05 294.327",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-230 1302.99L1502.05 302.987",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-225 1311.65L1507.05 311.647",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-220 1320.31L1512.05 320.307",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-215 1328.97L1517.05 328.968",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210 1337.63L1522.05 337.628",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205 1346.29L1527.05 346.288",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-200 1354.95L1532.05 354.948",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-195 1363.61L1537.05 363.609",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-190 1372.27L1542.05 372.269",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-185 1380.93L1547.05 380.929",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180 1389.59L1552.05 389.589",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-175 1398.25L1557.05 398.25",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170 1406.91L1562.05 406.91",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165 1415.57L1567.05 415.57",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-160 1424.23L1572.05 424.23",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-155 1432.89L1577.05 432.891",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-150 1441.55L1582.05 441.551",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-145 1450.21L1587.05 450.211",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-140 1458.87L1592.05 458.872",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-135 1467.53L1597.05 467.532",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-130 1476.19L1602.05 476.192",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 1484.85L1607.05 484.852",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120 1493.51L1612.05 493.513",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-115 1502.17L1617.05 502.173",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-110 1510.83L1622.05 510.833",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105 1519.49L1627.05 519.493",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-100 1528.15L1632.05 528.153",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95 1536.81L1637.05 536.814",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-90 1545.47L1642.05 545.474",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85 1554.13L1647.05 554.134",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80 1562.79L1652.05 562.794",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-75 1571.45L1657.05 571.455",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70 1580.12L1662.05 580.115",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-65 1588.78L1667.05 588.775",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60 1597.44L1672.05 597.436",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-55 1606.1L1677.05 606.096",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50 1614.76L1682.05 614.756",
    stroke: "#E6EAED",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2748_47077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 922,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenyumWorkingHoursBg);
export default __webpack_public_path__ + "static/media/ZenyumWorkingHoursBg.820f7b7157ff0261142020b2c064967f.svg";
export { ForwardRef as ReactComponent };